// Single source of truth for all plan pricing (in GBP)
// Change prices HERE and they update everywhere automatically

export const PLANS = {
  free: {
    name: 'Free Tier',
    videos: 5,
    clips: 15,
    price: { monthly: 0, yearly: 0 }
  },
  pro: {
    name: 'Creator Pro',
    videos: 20,
    clips: 60,
    price: { 
      monthly: 9.99, 
      yearly: 7.99,
      yearlyTotal: 95.90,
      yearlySaving: 24.00,
      annual: 95.90
    }
  },
  business: {
    name: 'Business',
    videos: 60,
    clips: 180,
    price: { 
      monthly: 24.99, 
      yearly: 19.99,
      yearlyTotal: 239.90,
      yearlySaving: 60.00,
      annual: 239.90
    }
  }
};

export const PRO_MONTHLY = PLANS.pro.price.monthly;
export const PRO_YEARLY = PLANS.pro.price.yearly;
export const BIZ_MONTHLY = PLANS.business.price.monthly;
export const BIZ_YEARLY = PLANS.business.price.yearly;
